import { FaRegEdit } from "react-icons/fa";
import { PeriodProvider } from "@/providers/Period";
import AuditOrdersProvider from "./AuditoriaPedidos/context/AudOrders";
import { lazy } from "react";

const AuditoriasDashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.AuditoriasDashboard })));
const Gestao = lazy(() => import("./Gestao").then((m) => ({ default: m.Gestao })));
const GestaoInventario = lazy(() => import("./GestaoInventario"));
const GestaoAuditoria = lazy(() => import("./Gestao1"));
const GeracaoAuditoria = lazy(() => import("./GeracaoAuditoria"));
const AuditoriaPedidosScreen = lazy(() => import("./AuditoriaPedidos/screen"));
const ModalItemsOrders = lazy(() => import("./AuditoriaPedidos/components/ModalItensDetails"));


const Module = {
  menuItem: {
    to: "/auditoria",
    title: "Auditoria",
    icon: FaRegEdit,
    id: 14,
    childrens: [
      {
        to: "/auditoria/gestao-auditoria",
        title: "Gestao ",
        fullTitle: "Gestao",
        id: 60,
      },
      {
        to: "/auditoria/geracao",
        title: "Geração",
        fullTitle: "Geração",
        id: 61,
      },
      {
        to: "/auditoria/gestao-inventario",
        title: "Gestão Inventario",
        fullTitle: "Gestão Inventario",
        id: 62,
      },
      {
        to: "/auditoria/auditoria-pedidos",
        title: "Auditoria de Pedidos",
        fullTitle: "Gestão Pedidos",
        id: 63,
      },
    ],
  },

  routes: [
    {
      path: "auditoria",
      element: <AuditoriasDashboard />,
    },
    {
      path: "/auditoria/gestao-auditoria",
      element: (
        <PeriodProvider>
          <GestaoAuditoria />
        </PeriodProvider>
      ),
    },
    {
      path: "/auditoria/geracao",
      element: (
        <PeriodProvider>
          <GeracaoAuditoria />
        </PeriodProvider>
      ),
      childrens: [
        { path: "novo", element: <GeracaoAuditoria /> },
      ],
    },
    {
      path: "/auditoria/gestao-inventario",
      element: (
        <GestaoInventario />
      ),
    },
    {
      path: "/auditoria/auditoria-pedidos",
      element: (
        <PeriodProvider>
          <AuditOrdersProvider>
            <AuditoriaPedidosScreen />
          </AuditOrdersProvider>
        </PeriodProvider>
      ),
      children: [
        {
          path: ":id/itens",
          element: <ModalItemsOrders />
        }
      ]
    },
  ],
};

export default Module;
